import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import React, { useEffect, useState } from "react";
import Loader from "../../../components/other/Loader";
import HeroSection from "../../../layout/HeroSection";
import AddBotModel from "../../component/AddBotModel";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import NoRecord from "../../../components/other/NoRecord";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPagination from "../../../layout/ReactPagination";
import PaginationDropdown from "../../../layout/PaginationDropdown";
import ConfirmationModal from "../../../components/confirmation modal";
import { pipGetTeamDirectory, pipViewDate } from "../../../utils/pip";
import {
  CreateBot,
  DeleteBot,
  DeleteTeam,
  fetchBotTypes,
  fetchTeamMember,
  fetchWeightClassCategories,
} from "../../../redux/action/authAction";

const TeamMemberDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, user } = useSelector((state) => state.authReducer);
  const teamMemberID = pipGetTeamDirectory()?.user?.id ||  null;

  const [bot_id, setBot_id] = useState(null);
  const { id } = useLocation()?.state?.data?.user ?? {};
  const [isAddBotModalOpen, setIsAddBotModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(10);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const paginateBots = user?.all_bots?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const teamDetails = [
    { label: "Team Name", value: user?.name ?? "#N/A" },
    { label: "Contact Email", value: user?.email ?? "#N/A" },
    { label: "Number", value: user?.number ?? "#N/A" },
    { label: "Position", value: user?.designation ?? "#N/A" },
    { label: "Website Link", value: user?.website_link ?? "#N/A" },
    { label: "Discord Name", value: user?.discord_name ?? "#N/A" },
    { label: "Bot Directory", value: user?.bot?.name ?? "#N/A" },
    { label: "Weight Classes", value: user?.weight_class?.name ?? "#N/A" },
    {
      label: "Primary League You Compete In",
      value: user?.tournament ?? "#N/A",
    },
    { label: "Country", value: user?.country ?? "#N/A" },
    { label: "State", value: user?.state ?? "#N/A" },
    { label: "City", value: user?.city ?? "#N/A" },
  ];

  useEffect(() => {
    dispatch(fetchBotTypes());
    dispatch(fetchTeamMember({ payload: { member_id: id } }));
    dispatch(fetchWeightClassCategories());
  }, []);

  const hadnleAddBotSubmit = (formdata) => {
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.botDirectory);
      }
    };
    dispatch(CreateBot({ payload: formdata, callback }));
  };

  const handleDeleteBot = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchTeamMember({ payload: { member_id: id } }));
      }
    };
    dispatch(
      DeleteBot({
        payload: {
          bot_id,
        },
        callback,
      })
    );
  };
  const handleDeleteTeam = () => {
    const callback = (res) => {
      if (res?.success) {
        localStorage.removeItem("Team-Member-Detail");
        navigate(pageRoutes?.more?.teamDirectory);
      }
    };
    dispatch(
      DeleteTeam({
        payload: {
          member_id: user?.id,
        },
        callback,
      })
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Robot Combat Team Details"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Team and Bot Directory",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <section className="mt-5 pt-5">
          <div className="container">
            <div className="row">
              <div class="col-md-8 mx-auto mb-5 pb-3">
                <div class="ct_team_card_head position-relative">
                  {id == teamMemberID && (
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#ct_delete_team"
                      type="button"
                      className="ct_team_edit_icon_3 ct_small_logout_btn rc_hero_btn_top_right"
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  )}
                  <div class="ct_overlay_hidden mx-auto">
                    <img
                      src={user?.profile_image ?? "/images/user_profile.png"}
                      alt=""
                    />
                  </div>
                  <div class="ct_team_title">
                    <h4>{user?.name ?? ""}</h4>
                    <p class="mb-0">{user?.designation}</p>
                    {teamDetails.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center gap-1 justify-content-between flex-wrap mt-3"
                      >
                        <a className="mb-0 ct_fs_16 text-white">{item.label}</a>
                        <a className="mb-0 ct_fs_16 text-white">{item.value}</a>
                      </div>
                    ))}
                  </div>
                </div>

                {user?.about && (
                  <div class="ct_team_info1">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${user?.about}`,
                      }}
                    />
                  </div>
                )}
                {id == teamMemberID && (
                  <div className="text-center">
                    <button
                      type="button"
                      onClick={() => setIsAddBotModalOpen(true)}
                      className="btn btn-secondary ct_btn_animate  mt-3 px-5 ms-auto"
                    >
                      + Add Bot
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <h2 className="section-title mb-5 text-center">Team Bots</h2>
                <div className="table-responsive">
                  <table className="table rc_table_design">
                    <thead>
                      <tr>
                        <th>Bot Image</th>
                        <th>Bot Name</th>
                        <th>Weight Class</th>
                        <th>Bot Type</th>
                        <th>Design Type</th>
                        <th>Date</th>
                        {id == teamMemberID && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {paginateBots &&
                        paginateBots?.length > 0 &&
                        paginateBots?.map((bot, index) => (
                          <tr>
                            <td>
                              <img src={bot?.image || ""} className="et_w_40" />
                            </td>
                            <td>{bot?.name || "N/A"}</td>
                            <td> {bot?.weight_class?.name ?? "#N/A"}</td>
                            <td>{bot?.bot_type?.name ?? "#N/A"}</td>
                            <td>{bot?.design_type || "#N/A"}</td>
                            <td>{pipViewDate(bot?.start_date) ?? "#N/A"}</td>
                            {id == teamMemberID && (
                              <td className="">
                                <a 
                                  href="javascript:void(0)"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_delete_bot"
                                  onClick={() => setBot_id(bot?.id)}
                                >
                                  <i class="fa-solid fa-trash-can text-danger"></i>
                                </a>
                              </td>
                            )}
                          </tr>
                        ))}
                      {paginateBots && paginateBots?.length <= 0 && (
                        <tr>
                          <td colSpan={7} className="border-0 py-3">
                            <NoRecord className="text-center mb-0" />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {user?.all_bots && user?.all_bots?.length > 10 && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mt-4 mx-3 mb-3">
                      <div>
                        <PaginationDropdown
                          onChange={(val) => {
                            setPerPageList(val);
                            setCurrentPage(0);
                          }}
                        />
                      </div>
                      <div>
                        <ReactPagination
                          pageCount={Math.ceil(
                            user?.all_bots?.length / listPerPages
                          )}
                          onPageChange={handlePageClick}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>

      {/* Add Bot Modal */}
      <AddBotModel
        user={user}
        isAddBotModalOpen={isAddBotModalOpen}
        setIsAddBotModalOpen={setIsAddBotModalOpen}
        hadnleAddBotSubmit={hadnleAddBotSubmit}
      />

      {/* confirmation model */}
      <ConfirmationModal
        id="ct_delete_bot"
        lable="delete this bot"
        handleYes={handleDeleteBot}
      />
      {/* confirmation model */}
      <ConfirmationModal
        id="ct_delete_team"
        lable="delete your team account"
        handleYes={handleDeleteTeam}
      />
    </>
  );
};

export default TeamMemberDetail;
